module.exports = __webpack_public_path__ + "static/media/passbook.13e69661.svg";